export type {Props as TabGroupProps} from "./TabGroup";
export type {Props as TabItemProps} from "./TabItem";

export {default as TabItem} from "./TabItem";
export {default as TabGroup} from "./TabGroup";
